<ng-container *ngIf="showCenter && loading">
  <mat-spinner class="init-spinner" color="primary" diameter="75"></mat-spinner>
</ng-container>

<div
  class="assign-container"
  *ngIf="!loading"
  [ngClass]="showCenter ? 'center' : ''"
>
  <div class="row row--atelier">
    <label>Klaarmaken</label>

    <mat-form-field
      class="ctrl ctrl__employee ctrl__employee--atelier"
      appearance="outline"
    >
      <mat-select
        [(ngModel)]="atelierEmployeeId"
        (ngModelChange)="updateAtelierEmployeeId()"
      >
        <mat-option
          *ngFor="let employee of assignOptions"
          [value]="employee.id"
        >
          {{ employee.user.firstName + ' ' + employee.user.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="ctrl ctrl__date ctrl__date--atelier"
      appearance="outline"
    >
      <input
        matInput
        [(ngModel)]="atelierDate"
        [matDatepicker]="pickerAtelier"
        (ngModelChange)="updateAtelierDate()"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="pickerAtelier"
      ></mat-datepicker-toggle>
      <mat-datepicker #pickerAtelier></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="row row--review">
    <label>Controle</label>

    <mat-form-field
      class="ctrl ctrl__employee ctrl__employee--review"
      appearance="outline"
    >
      <mat-select
        [(ngModel)]="reviewEmployeeId"
        (ngModelChange)="updateReviewEmployeeId()"
      >
        <mat-option
          *ngFor="let employee of assignOptions"
          [value]="employee.id"
        >
          {{ employee.user.firstName + ' ' + employee.user.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="ctrl ctrl__date ctrl__date--review"
      appearance="outline"
    >
      <input
        matInput
        [(ngModel)]="reviewDate"
        [matDatepicker]="pickerReview"
        (ngModelChange)="updateReviewDate()"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="pickerReview"
      ></mat-datepicker-toggle>
      <mat-datepicker #pickerReview></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="row row--sequence">
    <label>Volgorde</label>

    <mat-form-field class="ctrl ctrl__sequence" appearance="outline">
      <input matInput type="number" [(ngModel)]="atelierSequence" />
    </mat-form-field>
  </div>

  <div class="row row--action">
    <button (click)="submitAssign()" class="btn btn--submit">Toewijzen</button>
  </div>
</div>
